// Full map-state serialization for share links + bookmarks. Captures enough to
// restore an identical view: camera, projection, active layer, filters, border
// config, and selected org/region. Compact JSON → base64url in the `?s=` param.

export const SHARE_PARAM = 's'

const b64urlEncode = (str) => btoa(unescape(encodeURIComponent(str)))
  .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
const b64urlDecode = (str) => decodeURIComponent(escape(
  atob(str.replace(/-/g, '+').replace(/_/g, '/'))
))

export const encodeState = (obj) => b64urlEncode(JSON.stringify(obj))
export const decodeState = (str) => {
  try { return JSON.parse(b64urlDecode(str)) } catch { return null }
}

export const buildShareUrl = (obj) =>
  `${window.location.origin}${window.location.pathname}?${SHARE_PARAM}=${encodeState(obj)}`

// Assemble the shareable/bookmarkable state object from the app's current state.
// `viewport` comes from the store; the rest from App.
export const assembleState = ({ viewport, isGlobeView, activeLayer, filters, border, org, region }) => ({
  v: 1,
  c: viewport?.center,
  z: viewport?.zoom,
  b: viewport?.bearing || 0,
  proj: isGlobeView ? 'globe' : 'mercator',
  layer: activeLayer || null,
  filters: filters || null,
  border: border || null,
  org: org ?? null,
  region: region ?? null,
})
